App = App || {};
App.ExportTitleList = (function ($) {
    return {
        init: _init
    };

    function _init() {
        if (!_myComponentIsOnPage()) {
            return;
        }

        let $body = $(document.body);

        _bindClickEvents($body);
        _bindKeyEvents($body);
    }

    function _myComponentIsOnPage() {
        return $('.export-title-list').length;
    }

    function _bindClickEvents($body) {
        $body.on('click', '.js-export-link', function (e) {
            if (_isSpaceKey(e)) {
                e.preventDefault();
            } else {
                e.preventDefault();
                let $exportLink = $(this);
                $exportLink.attr('aria-expanded', 'true');

                let $siblings = $exportLink.siblings();
                let $modal = $siblings.filter('.js-export-title-list-modal');
                let $overlay = $siblings.filter('.js-modal-overlay');
                let $downloadBtn = $modal.find('.js-download-btn');
                let $errorMessage = $modal.find('.js-error-message');
                let $startedMessage = $modal.find('.js-export-title-started');
                $modal.removeClass('hide');
                $overlay.show();
                $downloadBtn.focus();
                $errorMessage.text('').addClass('hide');
                if (!$downloadBtn.hasClass('disabled')) {
                    $startedMessage.addClass('hide');
                }

                SCM.trapFocus.publicTrapFocus($modal, $modal.find('.js-close-modal'), document.activeElement);
            }
        });

        $body.on('click', '.js-close-modal', function () {
            let $exportTitleList = $(this).closest('.export-title-list');
            _closeModal($exportTitleList);
        });

        $body.on('click', '.js-modal-overlay', function () {
            let $exportTitleList = $(this).closest('.export-title-list');
            _closeModal($exportTitleList);
        });
    }

    function _bindKeyEvents($body) {
        $body.on('keyup', function (e) {
            if (e && e.code && e.code.toLowerCase() === 'escape') {
                e.preventDefault();
                let $exportTitleList = $('.export-title-list');
                _closeModal($exportTitleList);
            }
        });

        $body.on('keydown', '.js-export-link', function (e) {
            if (e && e.code && e.code.toLowerCase() === 'enter') {
                e.preventDefault();
                var $exportLink = $(this);
                $exportLink.blur();
                $exportLink.click();
            } else if (_isSpaceKey(e)) {
                e.preventDefault();
            }
        });

        $body.on('keydown', '.js-close-modal', function (e) {
            if (e && e.code && e.code.toLowerCase() === 'enter') {
                e.preventDefault();
                $(this).click();
            } else if (_isSpaceKey(e)) {
                e.preventDefault();
            }
        });

        $body.on('click', '.js-download-btn', function () {
            var queryString = window.location.search;
            var searchSummaryText = _getSearchSummaryText();

            var $formContainer = $('.js-export-title-list-modal');
            var captchaResponse = SCM.Captcha.GetCaptchaResponse($formContainer);
            var $errorMessage = $formContainer.find('.js-error-message');
            $errorMessage.addClass('hide');

            var $downloadBtn = $(this);
            $downloadBtn.addClass('disabled');

            var url = '/Solr/ExportResults';
            if (queryString) {
                url += queryString;
            }
            if (searchSummaryText) {
                url += (queryString ? '&' : '?') + 'searchSummaryText=' + searchSummaryText;
            }

            if (captchaResponse) {
                url += (queryString || searchSummaryText ? '&' : '?') + 'captchaResponse=' + captchaResponse;
            }
            else
            {
                $errorMessage.text('Please complete the CAPTCHA to continue.').removeClass('hide');
                $downloadBtn.removeClass('disabled');
                return;
            }

            let $startedMessage = $formContainer.find('.js-export-title-started');
            $startedMessage.removeClass('hide');

            $formContainer.addClass('wait');
            SCM.Ajax.get(url, {})
                .expectBlob()
                .then(function (blobResult) {
                    if (blobResult.fileName == 'Error.csv') {
                        blobResult.blob.text().then((errorMessage) => {
                            _showError($formContainer, $downloadBtn, $errorMessage, $startedMessage, errorMessage);
                        });
                    }
                    else {
                        // Create a URL for the file
                        var url = window.URL.createObjectURL(blobResult.blob);

                        // Create a temporary link and click it
                        var a = document.createElement('a');
                        a.href = url;
                        a.download = blobResult.fileName;
                        document.body.append(a);
                        a.click();
                        a.remove();
                        _closeModalAfterDownload($downloadBtn);
                        $formContainer.removeClass('wait');
                        $startedMessage.addClass('hide');
                    }
                })
                .catch(function (reason) {
                    _showError($formContainer, $downloadBtn, $errorMessage, $startedMessage, reason.statusText);
                });
        });
    }

    function _showError($formContainer, $downloadBtn, $errorMessage, $startedMessage, message) {
        $errorMessage.text(message).removeClass('hide');
        $startedMessage.addClass('hide');
        $downloadBtn.removeClass('disabled');
        SCM.Captcha.ResetCaptcha($formContainer);
        $formContainer.removeClass('wait');
    }

    function _closeModalAfterDownload($downloadBtn) {
        $downloadBtn.removeClass('disabled');
        let $exportTitleList = $downloadBtn.closest('.export-title-list');
        _closeModal($exportTitleList);
    }

    function _getSearchSummaryText() {
        var labels = $('.sr-facet-label, .sr-description').map(function () {
            if ($(this).hasClass('sr-description')) {
                return 'Search Query: ' + $(this).text().trim();
            } else {
                return $(this).text().trim();
            }
        }).get();

        return labels.join(', ');
    }

    function _isSpaceKey(event) {
        return event && event.key && event.key === ' ';
    }

    function _closeModal($exportTitleList) {
        let $modal = $exportTitleList.find('.js-export-title-list-modal');
        let $overlay = $exportTitleList.find('.js-modal-overlay');

        $modal.addClass('hide');
        $overlay.hide();

        let $exportLink = $exportTitleList.find('.js-export-link');
        if ($exportLink.length) {
            $exportLink.attr('aria-expanded', 'false');
            $exportLink.focus();
        }
    }
})(jQuery);